import { useIntervalEffect } from "@react-hookz/web";
import React from "react";

export function useNow({ updateIntervalMs = 60_000 }: { updateIntervalMs?: number | false } = {}) {
  const [now, setNow] = React.useState(() => new Date());
  useIntervalEffect(() => setNow(new Date()), updateIntervalMs === false ? undefined : updateIntervalMs);
  return now;
}
